import React, { Component } from "react"
import classes from "./nav.module.css"
import logo from "../../images/logo2.png"
import { Link } from "gatsby"

class Nav extends Component {
  constructor(props) {
    super(props)
    this.state = {
      topnavId: "bar",
    }
  }

  toggleHandler = e => {
    e.preventDefault()
    let toggle = this.state.topnavId
    this.setState({
      topnavId: toggle === "responsive" ? "bar" : "responsive",
    })
  }
  render() {
    return (
      <div className={classes.topnav} id={this.state.topnavId}>
        <a href="/">
          <img src={logo} alt="logo" />
        </a>
        <a href="/#about">About</a>
        <a href="/#contact">Contact</a>
        <div className={classes.dropdown}>
          <button className={classes.dropbtn}>
            Services
            {/*<i class="fa fa-caret-down"></i>*/}
          </button>
          <div className={classes.dropcontent}>
            <Link to="/semi-permanent-make-up">Semi permanent make-up</Link>
            <Link to="/laser-hair-removal">Laser hair removal</Link>
            <Link to="/facials">Facials</Link>
            <Link to="/body-treatments">Body treatments</Link>
            <Link to="/waxing">Waxing</Link>
            <Link to="/eyebrow-and-eyelash-treatments">
              Eyebrow and eyelash treatments
            </Link>
          </div>
        </div>
        <a href="/pricelist">Price list</a>

        <Link to="https://bookings.gettimely.com/smartskin/bb/book">Book Online</Link>

        <a href={void 0} className={classes.icon} onClick={this.toggleHandler}>
          &#9776;
        </a>
      </div>
    )
  }
}

export default Nav
